<template>
  <div class="t-d-i-footer">
    <div class="t-d-i-footer-top">
      <a-row class="ftop-font16">
        <a-col :span="24">联系我们</a-col>
      </a-row>
      <a-row class="ftop-font14">
        <a-col :span="12">
          <span class="tdi-link" @click="goToLinkPage('blood')"
            >上海儿童医学中心</span
          >
        </a-col>
        <a-col :span="12">
          <span class="tdi-link" @click="goToLinkPage('ronglian')"
            >荣联科技集团股份有限公司</span
          >
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <span class="iconfont icon-dianhua"></span>+86 021 - 38626161
        </a-col>
        <a-col :span="12">
          <span class="iconfont icon-dianhua"></span>+86 010 - 62602000
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <span class="iconfont icon-youjian"></span>liuyu@scmc.com.cn
        </a-col>
        <a-col :span="12">
          <span class="iconfont icon-youjian"></span>bioservice@ronglian.com
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <span class="iconfont icon-dingwei"></span>上海市东方路1678号
        </a-col>
        <a-col :span="12">
          <span class="iconfont icon-dingwei"></span
          >北京市朝阳区酒仙桥北路甲10号院106号楼荣联科技大厦
        </a-col>
      </a-row>
    </div>
    <div class="t-d-i-footer-bottom">
      京ICP备14049550号 | CopyRight c 2015-{{ new Date().getFullYear() }}
      荣联科技集团股份有限公司版权所有 服务条款 ｜ 隐私政策
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goToLinkPage(type) {
      switch (type) {
        case "blood":
          this.$router.push("/home");
          break;
        case "ronglian":
          window.open("http://www.ronglian.com/");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.t-d-i-footer-top {
  .iconfont {
    margin-right: 15px;
  }
  .ftop-font16 {
    font-size: 16px;
    font-weight: 600;
  }
  .ftop-font14 {
    font-size: 14px;
    font-weight: 600;
  }
  background-color: #13223d;
  font-size: 12px;
  color: #b5b5b5;
  line-height: 32px;
  padding: 22px 120px;
}

.t-d-i-footer-bottom {
  height: 35px;
  font-size: 12px;
  color: #b5b5b5;
  line-height: 35px;
  text-align: center;
  background-color: #000;
}
</style>